const RATE_TIER_KEYS = [
    { key: "hourlyRate", titleKey: "hourly" },
    { key: "dailyRate", titleKey: "daily" },
    { key: "weeklyRate", titleKey: "weekly" },
    { key: "monthlyRate", titleKey: "monthly" },
];

export const MOBILE_CAR_RATE_TIERS = RATE_TIER_KEYS;

export const formatCarLocationLabel = (car) => {
    const loc = car?.location;
    const parts = [loc?.address, loc?.city, loc?.state].filter(Boolean);
    if (parts.length > 0) {
        return parts.join(", ");
    }
    if (car?.baseLocation) {
        return car.baseLocation;
    }
    return null;
};

export const getCarPricingSource = (car, isCarPricingMode) =>
    isCarPricingMode ? car?.rate : typeof car?.category === "object" ? car.category : null;

export const getCarRateTierDisplay = (source, tierKey, t) => {
    const tier = source?.[tierKey];
    if (!tier || tier.disabled || !tier.rate) {
        return { label: t("disabled"), isDisabled: true };
    }
    return { label: `$${tier.rate}`, isDisabled: false };
};

export const isCarInsuranceLinked = (car) => car?.insuranceVehicleInfo?.active === true;
